// extracted by mini-css-extract-plugin
export default {"wrapper":"check_box_wrapper__YRFNT","input":"check_box_input__dOgpp"};